import { render, staticRenderFns } from "./FeatureRequestModal.vue?vue&type=template&id=7e75d02a&scoped=true"
import script from "./FeatureRequestModal.vue?vue&type=script&lang=js"
export * from "./FeatureRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e75d02a",
  null
  
)

export default component.exports